import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { VIEWPORT } from "@faire/help-center/views/eventEnum";
import { trackHelpCenterNavSearchHeaderView } from "@faire/web-api/events/helpCenter/view/navSearchHeader";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export var useTrackHelpCenterMainPagesView = function useTrackHelpCenterMainPagesView(experiment) {
  var _getRetailerToken, _getBrandToken;
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var pathname = useLocation().pathname;
  useEffect(function () {
    trackHelpCenterNavSearchHeaderView(isMobile ? VIEWPORT.WEB_MOBILE : VIEWPORT.WEB_DESKTOP, retailerToken, brandToken, pathname, experiment);
  }, [brandToken, experiment, isMobile, pathname, retailerToken]);
};